import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { IdentityService } from '../identity.service';

type ClaimString = string | string[] | undefined;

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[hasClaim]' })
export class HasClaimDirective {
  private hasView = false;
  private claim: ClaimString;
  private claimValues: ClaimString;
  private operator: 'OR' | 'AND' | undefined;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private identityService: IdentityService
  ) { }

  @Input() set hasClaimValue(claimValues: ClaimString) {
    this.claimValues = claimValues;
    this._checkClaim();
  }

  @Input() set hasClaimOperator(operator: 'OR' | 'AND' | undefined) {
    this.operator = operator;
    this._checkClaim();
  }

  @Input() set hasClaim(claim: ClaimString) {
    this.claim = claim;
    this._checkClaim();
  }

  private _checkClaim() {
    let hasClaim = true;
    if (typeof this.claim !== 'undefined') {
      if (Array.isArray(this.claim)) {
        hasClaim = this.hasClaimInArray(this.claim);
      } else {
        hasClaim = this.hasSingleClaim(this.claim);
      }
    }

    if (hasClaim && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasClaim && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private hasClaimInArray(claim: string[]): boolean {
    return this.operator === 'AND'
      ? claim.every((c, i) => this.identityService.hasClaim(c, this.getClaimValue(i)))
      : claim.some((c, i) => this.identityService.hasClaim(c, this.getClaimValue(i)));
  }

  private hasSingleClaim(claim: string): boolean {
    if (typeof this.claimValues === 'undefined') {
      return this.identityService.hasClaim(claim);
    }

    if (typeof this.claimValues !== 'object') {
      return this.identityService.hasClaim(claim, this.claimValues);
    }

    return this.operator === 'AND'
      ? this.claimValues.every((value) => this.identityService.hasClaim(claim, value))
      : this.claimValues.some((value) => this.identityService.hasClaim(claim, value));
  }

  private getClaimValue(index: number) {
    return Array.isArray(this.claimValues) && this.claimValues.length > index ? this.claimValues[index] : undefined;
  }
}
